import React, { useState } from 'react'
import { EmptyIcon } from '../../../assets/icons';



const ExpenseUploadSuccess = ({closeModal}:any) => {

  
    return (
        <>
          <div className="h-screen">
            <div className="  text-[25px] font-bold text-center ">
              <h1>
              Your upload is being processed
              </h1>
              <div className='text-[16px] mt-[2em] font-normal text-center'>
              <h3>
              You’ll be notified if there’s an issue processing your your upload. Check your notifications shortly.  
              </h3>
              </div>
              </div>
              <div className="mt-[2em] ml-[5em] ">
              <EmptyIcon />
            </div>
            <button
        className="w-[215px] h-[48px] mt-[2em] ml-[6em] rounded-md text-[#FFFFFF] border border-[#044E97] text-[16px] font-medium bg-[#044E97]"
          onClick={closeModal}
        >
        Go Back To Expense
        </button>
          </div>
        </>
      );
    };

export default ExpenseUploadSuccess